export default "__VITE_ASSET__Dhv9093s__"